import type { ReplaceActiveNavigationType } from 'actions/types';

export const REPLACE_ACTIVE_NAVIGATION: ReplaceActiveNavigationType =
  '@@app/navigation/REPLACE_ACTIVE_NAVIGATION';
